<div class="container-fluid dashboard-container">
  <!-- Bot Selection -->
  <div class="row mb-4">
    <mat-card class="h-100">
      <mat-card-content>
        <div class="col-12">
          <div class="filter-bar d-flex flex-wrap gap-3 align-items-center">
            <div class="bot-selection d-flex gap-2">
              <div *ngFor="let bot of availableBots" class="bot-item d-flex flex-column align-items-center">
                <button class="bot-circle" [ngClass]="{
                          'selected': selectedBot === bot.key,
                          'dimmed': selectedBot && selectedBot !== bot.key
                        }" (click)="selectBot(bot.key)" [title]="bot.name"
                  [attr.aria-label]="'Select ' + bot.name + ' bot'">
                  <img [src]="bot.key === 'lwazi' ? 'assets/images/lwaziImage.png' 
                              : bot.key === 'lesedi' ? 'assets/images/lesediImage.png' 
                              : bot.key === 'kitso' ? 'assets/images/kitsoDbeImage.png' 
                              : bot.key === 'kitsozazi' ? 'assets/images/kitsoDbeImage.png'
                              : bot.key === 'kitsoecd' ? 'assets/images/kitsoDbeImage.png'
                              : bot.key === 'kitsoai' ? 'assets/images/kitsoDbeImage.png'
                              : bot.key === 'mpilo' ? 'assets/images/mpiloImage.png'
                              : 'assets/images/default.png'" [alt]="bot.name + ' Image'" class="bot-image">
                </button>
                <div class="bot-name d-flex flex-column align-items-center" [ngClass]="{
                       'selected': selectedBot === bot.key,
                       'dimmed': selectedBot && selectedBot !== bot.key
                     }">
                  <span class="bot-name-main">{{
                    bot.key === 'kitsoecd' ||
                    bot.key === 'kitsozazi' ||
                    bot.key === 'kitsoai' ||
                    bot.key === 'kitso' ? 'Kitso' : bot.name }}</span>
                  <span class="bot-name-sub" *ngIf="bot.key === 'kitsoecd'">ECD</span>
                  <span class="bot-name-sub" *ngIf="bot.key === 'kitsozazi'">Zazizandi</span>
                  <span class="bot-name-sub" *ngIf="bot.key === 'kitsoai'">AI</span>
                  <span class="bot-name-sub" *ngIf="bot.key === 'kitso'">Onlie Saftey</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div class="report-content-area" *ngIf="!isLoading && !error">
    <!-- <router-outlet name="reportSection"></router-outlet> -->
    <div *ngIf="this.selectedBot === 'kitso' ">
      <app-kitso-report></app-kitso-report>
    </div>
    <div *ngIf="this.selectedBot === 'kitsoecd' ">
      <app-kitsoecd-report></app-kitsoecd-report>
    </div>
    <div *ngIf="this.selectedBot === 'kitsozazi' ">
      <app-kitsozazi-report></app-kitsozazi-report>
    </div>
    <div *ngIf="this.selectedBot === 'kitsoai' ">
      <app-kitsoai-report></app-kitsoai-report>
    </div>
    <div *ngIf="this.selectedBot === 'lesedi' ">
      <app-lesedi-report></app-lesedi-report>
    </div>
    <div *ngIf="this.selectedBot === 'lwazi' ">
      <app-lwazi-report></app-lwazi-report>
    </div>
    <div *ngIf="this.selectedBot === 'mpilo' ">
      <app-mpilo-report></app-mpilo-report>
    </div>
  </div>
</div>